export const getCaretRangeAtPoint = (clientX, clientY) => {
  if (document.caretRangeFromPoint) {
    return document.caretRangeFromPoint(clientX, clientY);
  }

  if (document.caretPositionFromPoint) {
    const position = document.caretPositionFromPoint(clientX, clientY);
    if (!position?.offsetNode) return null;

    const range = document.createRange();
    range.setStart(position.offsetNode, position.offset);
    range.collapse(true);
    return range;
  }

  return null;
};

export const getNearestCaretRangeInBlock = (blockElement, clientX, clientY) => {
  if (!blockElement) return null;


  const walker = document.createTreeWalker(blockElement, 4);
  let textNode = walker.nextNode();
  let best = null;

  while (textNode) {
    const length = textNode.nodeValue?.length || 0;

    for (let offset = 0; offset <= length; offset += 1) {
      const range = document.createRange();
      range.setStart(textNode, offset);
      range.collapse(true);

      let rect = range.getBoundingClientRect();
      let caretLeft = rect.left;


      if ((!rect || rect.height <= 0) && length > 0) {
        const glyphOffset = Math.min(offset, length - 1);
        const glyphRange = document.createRange();
        glyphRange.setStart(textNode, glyphOffset);
        glyphRange.setEnd(textNode, glyphOffset + 1);
        rect = glyphRange.getBoundingClientRect();
        caretLeft = offset > glyphOffset ? rect.right : rect.left;
      }

      if (!rect || rect.height <= 0 || !Number.isFinite(caretLeft)) continue;

      const verticalDistance =
        clientY < rect.top
          ? rect.top - clientY
          : clientY > rect.bottom
            ? clientY - rect.bottom
            : 0;

      const score = verticalDistance * 10000 + Math.abs(clientX - caretLeft);

      if (!best || score < best.score) {
        best = { score, range };
      }
    }

    textNode = walker.nextNode();
  }

  return best?.range || null;
};
